/** Markers embedded in `state.log` strings so the in-game log can render
 *  card names as clickable detail-view links without changing the log's
 *  on-the-wire shape (still a `string[]` in GameState).
 *
 *  Format: `{{card:<id>|<display name>}}`.
 *
 *  - The `{{` / `}}` brackets are not characters that appear in card
 *    names, so we can safely scan with a regex.
 *  - The `|` separator is also not a character that appears in card
 *    ids (slugs are alphanumeric + hyphen) or card names.
 *  - The display name is preserved verbatim — the renderer escapes it
 *    for HTML safety on output, since log text is otherwise free-form.
 *
 *  The engine writes markers via `logCardLink`; the renderer parses them
 *  via `LOG_CARD_LINK_RE`. Keep the two in lockstep — if the syntax ever
 *  changes, both ends update together. */

export interface CardLike {
  id: string;
  name: string;
}

export function logCardLink(def: CardLike): string {
  return `{{card:${def.id}|${def.name}}}`;
}

/** Global match of every `{{card:id|name}}` token in a log entry. The
 *  capture groups are (1) id, (2) display name. */
export const LOG_CARD_LINK_RE = /\{\{card:([^|}]+)\|([^}]+)\}\}/g;
